import { useEffect } from 'react'
import { Drawer } from '@jisr-hr/design-system'
import { useDispatch, useSelector } from 'utils/hooks'
import { toggleNotificationsPanel } from 'redux/appNotifications/actionCreators'
import { unreadNotificationsLoad } from 'redux/appNotifications/markAsRead/actionCreators'

import NotificationsPanel from './NotificationsPanel'
import Notifications from './Notifications'
import styles from './styles.module.css'

export default function AppNotifications(): JSX.Element {
  const dispatch = useDispatch()
  const isNotificationsOpen = useSelector(({ appNotifications }) => appNotifications.isOpen)

  useEffect(() => {
    dispatch(unreadNotificationsLoad())
  }, [])

  return (
    <>
      <Drawer
        active={isNotificationsOpen}
        onClose={(): void => {
          dispatch(toggleNotificationsPanel(false))
        }}
        content={<NotificationsPanel />}
        className={styles.drawerContainer}
      />

      <Notifications />
    </>
  )
}
